module.exports = __webpack_public_path__ + "static/media/Skiddo_gaussian2.9661cf74.png";